/// Training context type ///
export class TrainingContext {
    constructor() {
        this.stage = "";
        this.trainingObjectMap = new Map();
        this.trainingEventMetaInformation = new Map();
    }
}
export class TrainingEvent {
    constructor(id, context, isInternalEvent = false) {
        this.isInternalEvent = isInternalEvent;
        this.id = id;
        this.type = this.constructor.staticType;
        this.context = context;
    }
}
TrainingEvent.staticType = undefined;
